export const INITIAL_TAB_CONFIG = {
  key: 'fullPath' as const,
  keepAlive: true,
  hideClose: false,
};


export const INITIAL_TAB_TYPE = "line" as const;
